import { database } from "../api/firebase";
import { get, ref } from 'firebase/database';
import { useAsync } from "react-async-hook";

export const NICKNAME_PLACEHOLDER = 'UNDEFINED_NICKNAME'

const getNickname = async (uid: string, roomcode: string): Promise<string> => {
  const nicknameRef = ref(database, `/bubbles/${roomcode}/users/${uid}/nickname`);
  const snapshot = await get(nicknameRef);
  return snapshot.val();
}

const useNickname = (uid: string, roomcode: string): string => {
  const asyncNickname = useAsync(getNickname, [uid, roomcode]);
  return asyncNickname.result || NICKNAME_PLACEHOLDER;
}

export default useNickname;
